import { render, staticRenderFns } from "./DownloadTab.vue?vue&type=template&id=3c985a1e&scoped=true&"
import script from "./DownloadTab.vue?vue&type=script&lang=js&"
export * from "./DownloadTab.vue?vue&type=script&lang=js&"
import style0 from "./DownloadTab.vue?vue&type=style&index=0&id=3c985a1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c985a1e",
  null
  
)

export default component.exports